import NorthEast from '@mui/icons-material/NorthEast';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { Link as RouterLink } from 'react-router-dom';

import { SmallButton } from '~components/Order/ordersDispatchStyledComponents';
import { companyOnboardingChecklistPath } from '~router/routePaths';
import { useStores } from '~store';
import { getEffectiveUserCompanyName } from '~utils/user/user-utils';

const CompanyOnboardingWizardHeader = observer(() => {
  const { userStore } = useStores();

  return (
    <Box
      data-test-id="company-onboarding-wizard-header"
      sx={(theme) => ({
        alignItems: 'center',
        backgroundColor: theme.brandV2.colors.treadGray9,
        borderBottom: `1px solid ${theme.palette.divider}`,
        display: 'flex',
        gap: 2,
        px: 3,
        py: 1,
      })}
    >
      <Typography noWrap sx={{ color: 'text.primary' }}>
        {getEffectiveUserCompanyName(userStore)}
        <Typography component="span" sx={{ color: 'text.secondary' }}>
          {` / ${t('company_onboarding.workspace_setup')}`}
        </Typography>
      </Typography>
      <Box sx={{ flexGrow: 1 }} />
      <SmallButton
        color="secondary"
        component={RouterLink}
        endIcon={<NorthEast sx={{ fontSize: 14 }} />}
        to={companyOnboardingChecklistPath}
        variant="text"
      >
        {t('company_onboarding.actions.save_and_exit')}
      </SmallButton>
    </Box>
  );
});

export default CompanyOnboardingWizardHeader;
